(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("perfect-scrollbar", [], factory);
	else if(typeof exports === 'object')
		exports["perfect-scrollbar"] = factory();
	else
		root["perfect-scrollbar"] = factory();
})(this, function() {
return 